export enum FeatureFlag {
  Subscriptions = 'subscriptions',
  Reservations = 'reservations',
}
